import { supabase } from '@/lib/supabase'
import { aggregateFromEvents, validEvidence, unknownAggregate, type Aggregate, type AggregateEvent } from '../../../supabase/functions/_shared/aggregateCore'
export { validAggregate, validEvidence } from '../../../supabase/functions/_shared/aggregateCore'
export type { Aggregate, AggregateEvidence } from '../../../supabase/functions/_shared/aggregateCore'

// Direct, read-only source RPC: no AI consent needed, no model calls, no local outbox
// or persistent cache promoted into server evidence. Schema/SQL absence -> unknown.
export async function loadTodayAggregates(familyId: string, personId: string, now = new Date()): Promise<Record<string, Aggregate>> {
  const to = now.toISOString(), from = new Date(now.getTime() - 86400000).toISOString()
  const specs = [['feeds', 'early_care.feeding.recorded'], ['diapers', 'early_care.diaper.recorded'], ['sleep', 'early_care.sleep']] as const
  return Object.fromEntries(await Promise.all(specs.map(async ([kind, type]) => {
    try {
      const r = await supabase.rpc('aggregate_events_evidence', { p_family_id: familyId, p_person_id: personId, p_event_type: type, p_from: from, p_to: to })
      if (r.error || !r.data || r.data.length !== 1) throw Error('Evidence unavailable')
      const { event_ids, ...fields } = r.data[0]
      const evidence: unknown = { ...fields, effective_event_ids: event_ids }
      if (!validEvidence(evidence) || Date.parse(evidence.interval_from) !== Date.parse(from) || Date.parse(evidence.interval_to) !== Date.parse(to)) throw Error('Invalid evidence')
      let rows: AggregateEvent[] = []
      if (evidence.effective_event_ids.length) {
        const r = await supabase.from('events').select('id,family_id,person_id,event_type,occurred_at,server_received_at,server_sequence')
          .eq('family_id', familyId).eq('person_id', personId).in('id', evidence.effective_event_ids).limit(500)
        if (r.error || !r.data) throw Error('Source records unavailable')
        rows = r.data as AggregateEvent[]
      }
      return [kind, aggregateFromEvents(kind, evidence, rows, familyId, personId)]
    } catch { return [kind, unknownAggregate('No verified totals for the last day yet.')] }
  })))
}
